import moment from "moment";
import AxiosService from "./axiosServices";
const axiosService = new AxiosService();

export default class MappingService {
  getMappingData = (projectId, forValue) => {
    const formattedValue = forValue === "viewOnly" ? "view_only" : forValue;
    return axiosService.Get(
      `api/cam/review-mapping-data/${projectId}/?data_for=${formattedValue}`,
    );
  };

  rejectMappingData = (payloadData) => {
    const data = {
      body: payloadData,
    };

    return axiosService.Post(`api/cam/reject-mapping/`, data);
  };

  validateMapping = (payloadData) => {
    const data = {
      body: payloadData,
    };

    return axiosService.Post(`api/cam/submit-mapping-review/`, data);
  };

  isSignatureUploaded = () => {
    return axiosService.Get(`api/cam/is-signature-uploaded/`);
  };

  esignHandle = (userName, userId, userRole, userPassword) => {
    const data = {
      body: {
        user_name: userName,
        user_id: userId,
        user_role: userRole,
        user_password: userPassword,
      },
    };
    return axiosService.Post(`api/cam/verify-user/`, data);
  };
}
